import React, { useState } from "react";
import { useCustomTranslation } from "../../../../helpers/translateHelpers";
import HomeInterventionsTable from "./HomeInterventionsTable";
import { Title } from "../../../../components";
import { InterventionTableQuery } from "../../../interventions/models";
import { useGetInterventionsQuery } from "../../../interventions/queries";
import { defaultHomeInterventionsTableQuery } from "./helper";

const HomePlannedInterventionsContent: React.FC = (): React.ReactElement => {
  const { tCommon } = useCustomTranslation();

  const [queryParams, setQueryParams] = useState<InterventionTableQuery>({
    ...defaultHomeInterventionsTableQuery,
    state: "Planned",
  });

  const query = useGetInterventionsQuery(queryParams);

  return (
    <div className="my-4">
      <Title title={tCommon("home_planned_interventions")} />
      <p className="mb-4">
        {tCommon("home_planned_interventions_description", {
          count: query.data?.total ?? 0,
        })}
      </p>
      <HomeInterventionsTable
        data={query.data?.data ?? []}
        isLoading={query.isLoading}
        queryParams={queryParams}
        setQueryParams={setQueryParams}
        total={query.data?.total ?? 0}
      />
    </div>
  );
};

export default HomePlannedInterventionsContent;
